import React, { useState, useEffect, useContext } from 'react';
import {Route, Routes} from "react-router-dom";

import Bo_Home from './bo/home.js';
import Bo_Ftg from './bo/ftg.js';
import Bo_Prm from './bo/prm.js';
import Bo_Dep from './bo/dep.js';
import Bo_Cat from './bo/cat.js';
import Bo_Reason from './bo/reason.js';
import Bo_Red from './bo/red.js';
import {withRouter} from "../lib/react/withRouter";
import sso from "../sso";

function pg_home() {

    var html =
    <div className="web-content">
      Hem
    </div>
    ;
    return html;
}

class Ta_Bo extends React.Component {
    //var sdo = useContext(SDO);
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = { pgid: 11, deps: [] };
      var po = {};
      po.prds = { "fid": "f06", "url": "/ta/bo/ftg", "name": "Företag", "active": false };
      po.menu = { "fid": "f06", "url": "/ta/bo/prm", "name": "Parametrar", "active": false };
      po.dep = { "fid": "f06", "url": "/ta/bo/dep", "name": "Avdelningar", "active": false };
      po.cat = { "fid": "f06", "url": "/ta/bo/cat", "name": "Kategorier", "active": false };
      po.reason = { "fid": "f06", "url": "/ta/bo/reason", "name": "Anledningar", "active": false };
      po.red = { "fid": "f06", "url": "/ta/bo/red", "name": "Röda Dagar", "active": false };
      this.state.po = po;
      this.state.pa = [];
      this.state.pa = Object.values(po);
  }
    fknGo(row) {
        sso.seo.sfkn = row;
        this.props.navigate(row.url);
    }
    br_css(row) {
        var css = {};
        if(sso.seo.sfkn && (row.url == sso.seo.sfkn.url)) css.color = "#080";
        //var brc = false;
        //if(row.url == sbo.state.url) brc = true;
        return css;
    }

  render() {

    return (
        <div className="web-app">
            { this.props.store.cfg.bread ?
                <div className="web-bread">
                    <div className="breadcrumb">
                        { this.state.pa.map((row, key) =>
                            <div key={key} className="breadcrumb-item" style={this.br_css(row)} onClick={() => this.fknGo(row)}>{row.name}</div>
                        )}
                        <div className="flex"></div>
                        <div className="cdigreen">{ sso.seo.sfkn ? sso.seo.sfkn.name : null }</div>
                    </div>
                </div>
                : null }
        <Routes>
            <Route path="/xx" component={pg_home} />
            <Route path="ftg" element={ <Bo_Ftg store={this.webStore} />} />
            <Route path="prm" element={ <Bo_Prm store={this.webStore} />} />
            <Route path="dep" element={ <Bo_Dep store={this.webStore} />} />
            <Route path="cat" element={ <Bo_Cat store={this.webStore} />} />
            <Route path="reason" element={ <Bo_Reason store={this.webStore} />} />
            <Route path="red" element={ <Bo_Red store={this.webStore} />} />
            <Route path="*" element={ <Bo_Home store={this.webStore} />} />
        </Routes>
    </div>
  );
}
}
//Sys.contextType = ADOContext;

export default withRouter(Ta_Bo);
